import { render } from "./IconMedium.vue?vue&type=template&id=38b5f470"
import script from "./IconMedium.vue?vue&type=script&lang=js"
export * from "./IconMedium.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__